<template>
  <form @submit.prevent="onSearch">
    <div class="row mt-5">
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div v-if="operationTypeDropdown && operationTypeDropdown.length">
          <SelectVue
              v-model="filters.operationType"
              :options="operationTypeDropdown"
              :is-clear="true"
              :placeholder="$t('course.socio_therapy_coaching.operation_type')"/>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div v-if="priceTypeDropdown && priceTypeDropdown.length">
          <SelectVue
              v-model="filters.priceType"
              :options="priceTypeDropdown"
              :is-clear="true"
              :placeholder="$t('course.socio_therapy_coaching.price_type')"/>
        </div>
      </div>
      <div class="col-lg-2 col-sm-12 col-12 d-flex d-lg-block justify-content-center">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import SelectVue from '@/components/SelectVue.vue';
import {defineEmits, defineProps, toRefs} from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  operationTypeDropdown: {
    type: Array,
    required: true,
  },
  priceTypeDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['search']);

// Use toRefs to maintain reactivity
const {filters} = toRefs(props);
const operationTypeDropdown = toRefs(props)['operationTypeDropdown'];
const priceTypeDropdown = toRefs(props)['priceTypeDropdown'];

function onSearch() {
  emit('search', 1, undefined, filters.value);
}

</script>

<style scoped>
</style>
